<template>
<div id="profile" class="profile profile-edit">

  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('edit_email.title') }}</h1>

  <!-- Container -->
    <section class="container">
    <div class="row">

      <edit-email-form @updateSuccess="updateSuccess"></edit-email-form>

    </div>
  </section>
    <!-- /Container -->

</div>
</template>

<script>
  import EditEmailForm from './EditEmailForm.vue'
  import {mapActions} from 'vuex';

  export default {
    components: {
      'edit-email-form': EditEmailForm
    },
    methods: {
      ...mapActions([
        'setAuthUser',
      ]),
      updateSuccess(data) {
        this.setAuthUser(data);
        this.$router.push({name: 'profile', params: { success_message: this.$i18n.t('edit_email.success') }});
      },
      back() {
        this.$router.push({name: 'profile'});
      }
    }
  }
</script>


<style lang="scss" scoped>
#profile {
  h2 {
  font-weight: bold;
    font-size: 23px;
    line-height: 41px;
    border-bottom: 1px solid #eeeeee;
    padding: 15px;
    color: #686868;
  }

}

@media screen and (min-width: 768px) {
  .main-center {
    width: 100%;
    max-width: 1036px;
    margin: 0 auto;
  }
}

</style>